module.exports = __webpack_public_path__ + "static/media/vod30.3dd7779c.png";